import * as React from 'react';
const PelleGrassaDelVisoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M90.41 57.96c.95-.43 1.92-.81 2.91-1.15 0 0 1.82-.86 6.68-1.54 11.71-1.62 23.89 1.78 30.05 12.39 3.8 6.25 5.52 13.76 4.9 21.07-.63 7.47-5.02 13.38-8.43 19.79-2.43 4.57-4.09 9.67-3.98 14.85M99.25 121.8c-4.34 3.2-9 5.77-14.14 7.27-3.58 1.04-8.09 2.09-11.54 0-1.5-.9-2.63-2.69-2.42-4.51.09-.79.43-1.53.52-2.32s-.09-1.39-.74-1.78c-.57-.34-1.12-.77-1.49-1.35s-.55-1.33-.35-2 .85-1.18 1.51-1.13c-.74-.12-1.45-.65-1.81-1.35s-.39-1.58-.08-2.31c.18-.42.45-.77.67-1.16s.39-.84.33-1.29-.32-.83-.75-.78c-.77-.37-1.56-.75-2.23-1.31-2.46-2.06-2.22-4.36-.42-6.86M130.49 145.1c-2.99-4.41-5.45-9.74-6.87-15.03M86.13 128.91c2 5.56 4.38 10.98 7.12 16.19"
      className="prefix__cls-2"
    />
    <path
      d="M107.58 95.59c.81-1.75 2.03-3.37 3.73-4.15 1.69-.79 3.9-.55 5.11.91.9 1.07 1.13 2.58 1.16 4.01.07 3.55-.94 7.12-2.85 10.05-.86 1.32-1.92 2.53-3.25 3.29-1.34.76-2.99 1.02-4.4.43"
      className="prefix__cls-2"
    />
    <path
      d="M111.35 99.9c-.36.94-.86 1.82-1.49 2.61-.03.03-.07.07-.11.05s.03-.09.03-.05"
      className="prefix__cls-2"
    />
    <circle cx={84.1} cy={82.17} r={17.94} className="prefix__cls-1" />
    <path
      d="M84.1 73.08s6.31 5.16 6.31 11.88a6.31 6.31 0 1 1-12.62 0c0-6.72 6.31-11.88 6.31-11.88"
      className="prefix__cls-1"
    />
    <path d="M85.69 84.81s-.21 1.09-1.05 1.34" className="prefix__cls-1" />
  </svg>
);
export default PelleGrassaDelVisoIcon;
